import { Avatar, Popover } from '@mantine/core';
import PrimaryButton from 'components/primaryButton';
import { useState } from 'react';

import { ReactComponent as EyeIcon } from 'assets/icons/eyeIcon.svg';
import { ReactComponent as EditIcon } from 'assets/icons/editIcon.svg';
import { ReactComponent as WhiteDownArrow } from 'assets/icons/whiteDownArrow.svg';
import { ReactComponent as MenuDots } from 'assets/icons/menudots.svg';
import dayjs from 'dayjs';
import AddNewStroryModal from './addnewstrorymodal';
// import Usedeleteblog from '../hooks/usedeleteblog';
//import useUpdateblog from '../hooks/useUpdateblog';
import PublishModal from './publishModal';
import DeleteStoryModal from './deletestoryModal';
import ViewStoryModal from './viewStoryModal';

const StoriesReviewTable = ({ data }) => {
  // const [publishPopover, SetPublishPopover] = useState(false);
  const [memuPopover, setMenuPopover] = useState(false);
  const [newStoryModal, setNewStoryModal] = useState(false);
  const [BlogId, setBlogId] = useState(null);
  const [publishModal, setPublishModal] = useState(false);
  const [publishData, setPublishData] = useState(null);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isViewModal, setIsViewModal] = useState(false);

  // const deleteBlogMutate = Usedeleteblog();
  //const UpdateBlogMutation = useUpdateblog();

  const extractContent = (s) => {
    const span = document.createElement('span');
    span.innerHTML = s;
    return span.textContent || span.innerText;
  };

  return (
    <>
      <tr>
        <td className='w-[250px]'>
          <p className='flex justify-start items-center gap-3 text-[#9B9B9B] pl-12'>
            <Avatar radius='xl' color='#FB7C51' src={data?.profile_picture}>
              {data?.user__first_name[0]?.toUpperCase()}
            </Avatar>
            {data?.user__first_name}
          </p>
        </td>
        <td className='text-[#FB7C51] text-center'>{data?.topic}</td>
        <td className='w-[350px]'>
          <h1 className='text-lg font-bold '>{data?.title}</h1>
          <p className='text-sm text-[#9B9B9B] mt-1'>
            {`${extractContent(data?.content).substring(0, 80)}........`}
          </p>
          <p className='text-[#9B9B9B] flex justify-between items-center mt-1'>
            {dayjs(`${data?.created_date}`).format('H:mm A , D MMM YYYY ')}
            <span>{data?.minutes} min read</span>
          </p>
        </td>
        <td>
          <div className='flex justify-center items-center gap-4'>
            <EyeIcon
              className='cursor-pointer'
              onClick={() => {
                setIsViewModal(true);
                setBlogId(data.id);
              }}
            />
            <EditIcon
              className='cursor-pointer'
              onClick={() => {
                setNewStoryModal(true);
                setBlogId(data.id);
              }}
            />
          </div>
        </td>
        <td>
          <div className='flex justify-center items-center gap-5'>
            {/* <Popover
              opened={publishPopover}
              onClose={() => SetPublishPopover(false)}
              className='z-0'
              target={ */}
            <button
              onClick={() => {
                setPublishModal(true);
                setPublishData(data?.published_on);
                setBlogId(data?.id);
              }}
            >
              <PrimaryButton>
                Publish <WhiteDownArrow className=' ml-2 h-5 w-5' />{' '}
              </PrimaryButton>
            </button>
            {/* /* }
              width={260}
              position='bottom'
            >
              <Checkbox label='https://some Domine Name' />
            </Popover> */}

            <Popover
              opened={memuPopover}
              onClose={() => setMenuPopover(false)}
              className='z-0'
              target={
                <MenuDots
                  className='cursor-pointer'
                  onClick={() => {
                    setMenuPopover(!memuPopover);
                  }}
                />
              }
              width={150}
              position='bottom'
            >
              <p
                className='text-[#9B9B9B] my-1 cursor-pointer '
                // onClick={() => {
                //   UpdateBlogMutation.mutate({
                //     id: data?.id,
                //     is_deleted: 'True',
                //   });
                // }}
                onClick={() => {
                  setMenuPopover(false);
                  setDeleteModalOpen(true);
                }}
              >
                {' '}
                Delete
              </p>
              <hr className='opacity-5' />
              <p className='text-[#9B9B9B] my-1 cursor-not-allowed'>
                Send to bottom
              </p>
            </Popover>
          </div>
        </td>
      </tr>
      <DeleteStoryModal
        deleteModal={isDeleteModalOpen}
        setDeleteModal={setDeleteModalOpen}
        blogdata={data}
      />
      <AddNewStroryModal
        newStoryModal={newStoryModal}
        setNewStoryModal={setNewStoryModal}
        BlogId={BlogId}
        setBlogId={setBlogId}
      />
      <ViewStoryModal
        isViewModal={isViewModal}
        BlogId={BlogId}
        setIsViewModal={setIsViewModal}
        newStoryModal={newStoryModal}
        blogdata={data}
      />
      <PublishModal
        setPublishModal={setPublishModal}
        publishModal={publishModal}
        publishData={publishData}
        setPublishData={setPublishData}
        BlogId={BlogId}
        setBlogId={setBlogId}
      />
    </>
  );
};

export default StoriesReviewTable;
